<div>
    <div class="modal-body fs" Id="invoiceId">
        <div class="row">
            <div class="col-12 overflow-auto" *ngIf="isPrintLogo">
                <banner-setting></banner-setting>
                <hr class="mb-2">
            </div>
            <div class="col-12 overflow-auto" *ngIf="!isPrintLogo">
                <pharmacy-header></pharmacy-header>
                <hr class="mb-2">
            </div>
            <div class="col-12 overflow-auto mrg">
                <table width="100%" class="heading1">
                    <tr class="heading2">
                        <th colspan="4" class="ht">
                            <b>Tax Invoice - OP Sales (Pharmacy)</b>
                        </th>
                    </tr>
                    <tr class="heading2">
                        <th class="padding-text">
                            Patient Name
                        </th>
                        <td class="padding-color">
                            <span class="margin-right">: </span>
                            <span [textContent]="bills[0].patientName"></span>
                        </td>
                        <th class="padding-text">
                            UMR No
                        </th>
                        <td class="padding-color">
                            <span class="margin-right">: </span>
                            <span [textContent]="bills[0].umrNo || '-----'"></span>
                        </td>
                    </tr>
                    <tr class="heading2">
                        <th class="padding-text">
                            Age/Gender
                        </th>
                        <td class="padding-color">
                            <span class="margin-right">: </span>
                            <span [textContent]="bills[0].dateOfBirth ? (bills[0].dateOfBirth | age:'days') : (bills[0].age ? (bills[0].age + ' yrs ') : 'N/A')"></span>
                            <span *ngIf="bills[0].gender"> ( <span [textContent]="bills[0].gender"></span> )</span>
                        </td>
                        <th class="padding-text">
                            Doctor Name
                        </th>
                        <td class="padding-color">
                            <span class="margin-right">: </span>
                            <span [textContent]="bills[0].providerName || '------'"></span>
                            <span *ngIf="bills[0].specializationName">/ <span [textContent]="bills[0].specializationName || '------'"></span></span>
                        </td>
                    </tr>
                    <tr>
                        <th class="padding-text">
                            <span>Invoice Date</span>
                        </th>
                        <td class="padding-color">
                            <span class="margin-right">: </span>
                            <span [textContent]="bills[0].createdDate | date:'dd/MM/yyyy, h:mm a'"></span>
                        </td>
                        <th class="padding-text">
                            Invoice No
                        </th>
                        <td class="padding-color">
                            <span class="margin-right">: </span>
                            <span [textContent]="bills[0].billNumber"></span>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="col-12 overflow-auto">
                <table width="100%" class="table-bordered textOfEveryVw">
                    <tbody>
                        <tr>
                            <th>SNo.</th>
                            <th>Medicine Name</th>
                            <th>Medicine Detail</th>
                            <th>Exp Dt</th>
                            <th>Qty</th>
                            <th>MRP</th>
                            <th>Taxable</th>
                            <th>GSTR(%)</th>
                            <th>CGST</th>
                            <th>SGST</th>
                            <th>IGST</th>
                            <th>Amount</th>
                        </tr>

                        <tr *ngFor="let bill of bills; index as i;" class="table-row">
                            <td class="text-color">{{i + 1}}</td>
                            <td class="text-color">
                                <div class="break-all max-width">{{bill.productName}}</div>
                                <div class="break-all max-width">({{bill.companyName}})</div>
                            </td>
                            <td class="text-color">
                                <div class="white-space-nowrap"><span class="font-weight-bold">HSN Code: </span> {{bill.hsnCode || '--'}}</div>
                                <div><span class="font-weight-bold">SH: </span> {{bill.scheduledDrug || '--'}}</div>
                                <div><span class="font-weight-bold">Batch No.: </span>{{bill.batchNumber}}</div>
                            </td>

                            <td><span [textContent]="bill.expiryDate | date:'MM/yyyy'"></span></td>
                            <td><span [textContent]="bill.quantity || '0'"></span></td>
                            <td><span [textContent]="(bill.mrp || 0) | currency: 'INR'"></span></td>
                            <td><span [textContent]="(bill.taxableAmount || 0) | currency: 'INR'"></span></td>
                            <td *ngIf="settingsData && settingsData.settingsId && settingsData.settingsId > 0 && settingsData.active" class="text-color">
                                <span [textContent]="(bill.discount || 0) | currency: 'INR'"></span>
                            </td>
                            <td><span [textContent]="bill.taxPercentage || 0 + '%'"></span></td>
                            <td><span [textContent]="bill.cgst | currency:'INR'"></span></td>
                            <td><span [textContent]="bill.sgst | currency:'INR'"></span></td>
                            <td><span [textContent]="bill.igst | currency:'INR'"></span></td>
                            <td><span [textContent]="(bill.total || 0) | currency: 'INR'"></span></td>
                        </tr>

                        <tr class="total-row">
                            <th colspan="1" class="text-color text-align-right">
                                <span [textContent]="totalTaxableAmt.toFixed(2) | currency:'INR'"></span>
                            </th>
                            <th colspan="1" class="text-color text-align-right">
                                <span [textContent]="totalCgst.toFixed(2) | currency:'INR'"></span>
                            </th>
                            <th colspan="1" class="text-color text-align-right">
                                <span [textContent]="totalSgst.toFixed(2) | currency:'INR'"></span>
                            </th>
                            <th colspan="1" class="text-color text-align-right">
                                <span [textContent]="totalIgst.toFixed(2) | currency:'INR'"></span>
                            </th>
                            <th colspan="1" class="text-color text-align-right">
                                <span [textContent]="t.toFixed(2) | currency:'INR'"></span>
                            </th>
                        </tr>

                    </tbody>
                </table>
            </div>

            <div class="col-12 overflow-auto">
                <table class="table table-bordered table-sm mt-2 heading1" *ngIf="gstCalculation.length > 0">
                    <tr class="heading1">
                        <th></th>
                        <th>CGST</th>
                        <th>SGST</th>
                        <th>IGST</th>
                        <th *ngIf="settingsData && settingsData.settingsId && settingsData.settingsId > 0 && settingsData.active">Discount</th>
                        <th>Taxable Value</th>
                    </tr>
                    <tbody>
                        <tr *ngFor="let gst of gstCalculation">
                            <ng-container *ngIf="gst.gst !== -1">
                                <td>GST @ {{gst.gst}}%</td>
                                <td class="text-align-right"><span [textContent]="gst.cgst | currency:'INR'"></span></td>
                                <td class="text-align-right"><span [textContent]="gst.sgst | currency:'INR'"></span></td>
                                <td class="text-align-right"><span [textContent]="gst.igst | currency:'INR'"></span></td>
                                <td *ngIf="settingsData && settingsData.settingsId && settingsData.settingsId > 0 && settingsData.active" class="text-align-right"><span [textContent]="gst.discount | currency:'INR'"></span></td>
                                <td class="text-align-right"><span [textContent]="gst.taxableAmount | currency:'INR'"></span></td>
                            </ng-container>
                            <ng-container *ngIf="gst.gst === -1">
                                <td><b>Total</b></td>
                                <td class="text-align-right"><span [textContent]="gst.cgst | currency:'INR'"></span></td>
                                <td class="text-align-right"><span [textContent]="gst.sgst | currency:'INR'"></span></td>
                                <td class="text-align-right"><span [textContent]="gst.igst | currency:'INR'"></span></td>
                                <td *ngIf="settingsData && settingsData.settingsId && settingsData.settingsId > 0 && settingsData.active" class="text-align-right"><span [textContent]="gst.discount | currency:'INR'"></span></td>
                                <td class="text-align-right"><span [textContent]="gst.taxableAmount | currency:'INR'"></span></td>
                            </ng-container>
                        </tr>
                        <tr>
                            <th colspan="4" class="text-align-right">OverAll Discount:</th>
                            <th colspan="2" class="text-align-right">
                                <span [textContent]="gstCalculation[gstCalculation.length - 1].discount | currency:'INR'"></span>
                            </th>
                        </tr>
                        <tr>
                            <th [attr.colspan]="settingsData && settingsData.settingsId && settingsData.settingsId > 0 && settingsData.active ? '4' : '3'" class="text-align-right">Net Amount:</th>
                            <th colspan="2" class="text-align-right">
                                <span [textContent]="bills[0].overallNetAmount.toFixed(2) | currency: 'INR'"></span>
                            </th>
                        </tr>
                        <tr class="heading1" *ngIf="bills[0].paidAmount">
                            <th class="text-align-right" [attr.colspan]="settingsData && settingsData.settingsId && settingsData.settingsId > 0 && settingsData.active ? '4' : '3'">Total Paid Amount:</th>
                            <th colspan="2" class="text-align-right">
                                <span [textContent]="bills[0].paidAmount.toFixed() | currency: 'INR'"></span>
                            </th>
                        </tr>
                        <tr class="heading1" *ngIf="(bills[0].overallNetAmount - bills[0].paidAmount) > 0">
                            <th colspan="2" class="text-align-right" [attr.colspan]="settingsData && settingsData.settingsId && settingsData.settingsId > 0 && settingsData.active ? '4' : '3'">Remaining amount to be paid:</th>
                            <th colspan="2" class="text-align-right">
                                <span [textContent]="(bills[0].overallNetAmount - bills[0].paidAmount).toFixed() | currency: 'INR'"></span>
                            </th>
                        </tr>
                        <!--</tbody>-->
                </table>

                <table>
                    <tr class="heading2">
                        <td class="font-weight-bold"><span [textContent]="'Rupees: ' + amtInWords + ' Only'"></span></td>
                    </tr>
                </table>
            </div>

            <div class="col-12 overflow-auto">
                <table class="heading1 mr" border="0" cellspacing="0">
                    <tr *ngIf="bills[0].reasonForDiscount">
                        <th colspan="3" class="text-align-left">Reason For Discount &nbsp;: <span class="reason-discount" [textContent]="bills[0].reasonForDiscount"></span></th>
                    </tr>
                    <tr>
                        <th colspan="3" class="text-align-left"><span>*Note: Goods once sold cannot be returned or exchanged.</span></th>
                    </tr>
                    <tr>
                        <th class="text-align-left" width="200">Created Date</th>
                        <th class="padding-right">
                            <span class="margin-right">: </span>
                            <span [textContent]="bills[0].createdDate | date:'dd/MM/yyyy, h:mm a'"></span>
                        </th>
                    </tr>
                    <tr>
                        <th class="text-align-left" width="200">Printed By</th>
                        <th class="padding-right">
                            <span class="margin-right">: </span>
                            <span [textContent]="page.userAccount.fullName"></span>
                        </th>
                    </tr>
                    <tr>
                        <th class="text-align-left" width="200">Printed Date</th>
                        <th class="padding-right">
                            <span class="margin-right">: </span>
                            <span [textContent]="currentDate | date :'d/MM/yyyy, h:mm a'"></span>
                        </th>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>